<template>
  <b-container>
    <b-card v-if="user.superuser" border-variant="danger" :header="$t('RegistrationInvite.header')" header-bg-variant="danger" header-text-variant="white" align="left">
      <b-form @submit="onSubmit" autocomplete="off">
        <b-row class="my-1">
          <b-col>
            <b-form-input :placeholder="$t('RegistrationInvite.emailPlaceholder')" v-model="email" type="email"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-3 justify-content-center">
          <b-button variant="danger" type="submit">{{ $t('RegistrationInvite.sendLink') }}</b-button>
        </b-row>
        <b-row class="mt-3 justify-content-center">
          <b-alert :show="error.received" variant="danger" class="text-center">{{error.msg}}</b-alert>
          <b-alert :show="success.received" variant="success" class="text-center">{{success.msg}}</b-alert>
        </b-row>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
/* CONTROLLER */
import RegistrationLinkService from '@/services/RegistrationLinkService'
import { mapGetters } from 'vuex'

export default {
  name: 'RegistrationInvite',
  data () {
    return {
      email: '',
      error: {
        received: false,
        msg: ''
      },
      success: {
        received: false,
        msg: ''
      }
    }
  },
  mounted () {
    // make sure only super user has access to this page
    this.checkUser()
  },
  methods: {
    onSubmit (e) {
      e.preventDefault()
      this.sendLink()
    },
    async sendLink () {
      try {
        const response = await RegistrationLinkService.assignLinkAndEmail({ email: this.email })

        // clear out form
        this.email = ''

        // print success message
        this.success.received = true
        this.success.msg = response.data.msg
      } catch (error) {
        this.error.received = true
        this.error.msg = error.response.data.error
      }
    },
    checkUser () {
      let smartdineLocalStorage = JSON.parse(window.localStorage.getItem('smartdine'))
      // first make sure user is logged in
      if (!this.isUserLoggedIn || !smartdineLocalStorage.token) {
        // then make sure user has superuser rights
        if (!this.user.superuser) {
          this.$router.push({ name: 'Home' })
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      isUserLoggedIn: 'isUserLoggedIn',
      user: 'user'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RegistrationInvite.vue